import { Flex, Text, Image, Box } from "@chakra-ui/react";
import { useNavigate, useLocation, Link } from "react-router-dom";
// import { useUserContext } from "context/UserContext";
import options, { accountOptions, mainOptions, otherOptions } from "./options";
import { useEffect, useState } from "react";
import { useUserContext } from "../../contexts/userContexts";

const RoutesGroup = ({ routes, location }) => {
  const [isOpen, setIsOpen] = useState(
    routes?.sublinks?.some((link) => link.url === location.pathname)
      ? true
      : false
  );

  useEffect(() => {
    if (routes?.sublinks?.some((link) => link.url === location.pathname)) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, routes]);

  if (isOpen) {
    return (
      <Box>
        <Flex
          alignItems={"center"}
          justify={"center"}
          padding={4}
          _hover={{
            cursor: "pointer",
            // backgroundColor: "#456EFF",
          }}
          borderRadius={"16px"}
          onClick={() => setIsOpen((p) => !p)}
        >
          <Image
            src={routes.icon}
            width={"18px"}
            height={"18px"}
            marginRight={3}
          />
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"16px"}
            lineHeight={"20px"}
            color={"#FFFFFF"}
            textTransform={"capitalize"}
            flex={1}
          >
            {routes.label}
          </Text>
          <Image
            // src={require("assets/svgs/Arrow_drop_down.svg").default}
            width={"18px"}
            height={"18px"}
          />
        </Flex>

        <Flex direction="column" width={"100%"} flex={1} paddingLeft={"20px"}>
          {routes.sublinks.map((route) => (
            <Link key={route.id} to={route.url}>
              <Flex
                alignItems={"center"}
                padding={4}
                bg={route.url === location.pathname ? "#456EFF" : "transparent"}
                _hover={{
                  cursor: "pointer",
                  // bg: route.url === location.pathname ? "#456EFF99" : "#456EFF",
                }}
                borderRadius={"16px"}
              >
                {route.activeIcon && (
                  <Image
                    src={
                      route.url === location.pathname
                        ? route.activeIcon
                        : route.inactiveIcon
                    }
                    width={"18px"}
                    height={"18px"}
                    marginRight={3}
                  />
                )}
                <Text
                  fontFamily={"PlusJakartaSansSemiBold"}
                  fontSize={"16px"}
                  letterSpacing={"0.6px"}
                  color={
                    route.url === location.pathname ? "#FFFFFF" : "#FFFFFF"
                  }
                  textTransform={"capitalize"}
                >
                  {route.label}
                </Text>
              </Flex>
            </Link>
          ))}
        </Flex>
      </Box>
    );
  }
  return (
    <Flex
      alignItems={"center"}
      justify={"center"}
      padding={4}
      _hover={{
        cursor: "pointer",
        // backgroundColor: "#456EFF",
      }}
      borderRadius={"16px"}
      onClick={() => setIsOpen((p) => !p)}
    >
      <Image src={routes.icon} width={"18px"} height={"18px"} marginRight={3} />
      <Text
        fontFamily={"PlusJakartaSansSemiBold"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#FFFFFF"}
        textTransform={"capitalize"}
        flex={1}
      >
        {routes.label}
      </Text>
      <Image
        // src={require("assets/svgs/Arrow_drop_down.svg").default}
        width={"18px"}
        height={"18px"}
      />
    </Flex>
  );
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useUserContext();
  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    const currentURL = location?.pathname;
    setCurrentPage(currentURL);
  }, []);

  const handleNavigation = (url) => {
    navigate(url);
    setCurrentPage(url);
  };

  return (
    <Flex
      position="fixed"
      direction="column"
      alignItems="center"
      paddingTop={12}
      h="100vh"
      w="280px"
      bg="#fff"
    >
      {/* Header */}
      <Box>
        <Text
          fontFamily="PlusJakartaSansSemiBold"
          fontSize={18}
          color="#000"
          textAlign="center"
          textTransform="capitalize"
        >
          KIDSWEAR COLLECTIVE
        </Text>
        <Text
          fontFamily="PlusJakartaSansBold"
          fontSize={12}
          color="#000"
          textAlign="center"
          textTransform="capitalize"
        >
          Business Operating System
        </Text>
      </Box>

      {/* Scrollable Menu */}
      <Flex
        direction="column"
        bg="#000"
        mt={8}
        flex="1"
        width="100%"
        borderTopRightRadius="16px"
        borderTopLeftRadius="16px"
        p={6}
        overflowY="auto"
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {mainOptions.length > 0 && (
          <>
            <Text
              fontFamily="PlusJakartaSansSemiBold"
              fontSize="12px"
              color="#FFFFFF"
              textTransform="capitalize"
              mb={3}
              p={4}
              pt={0}
            >
              main
            </Text>
            {mainOptions.map((option) => (
              <Flex
                key={option.id}
                onClick={() => handleNavigation(option.url)}
                alignItems="center"
                borderRadius="16px"
                p={4}
                bg={option.url === currentPage ? "#456EFF" : "transparent"}
                _hover={{
                  cursor: "pointer",
                  bg: option.url === currentPage ? "#456EFF" : "transparent",
                }}
              >
                <Image
                  src={
                    option.url === currentPage
                      ? option.activeIcon
                      : option.inactiveIcon
                  }
                  w="18px"
                  h="18px"
                  mr={3}
                />
                <Text
                  fontFamily="PlusJakartaSansSemiBold"
                  fontSize="16px"
                  color="#FFFFFF"
                  textTransform="capitalize"
                >
                  {option.label}
                </Text>
              </Flex>
            ))}
          </>
        )}
      </Flex>

      {/* Fixed Logout Button */}
      <Flex
        p={8}
        bg="black"
        width="100%"
        // borderTop="1px solid #FFFFFF30"
        onClick={() => {
          signOut();
          navigate("/");
        }}
        cursor="pointer"
        // justifyContent="center"
      >
        <Text
          fontFamily="PlusJakartaSansSemiBold"
          fontSize="16px"
          color="#FFFFFF"
          textTransform="capitalize"
        >
          Logout
        </Text>
      </Flex>
    </Flex>
  );
};


export default Sidebar;
